import * as React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import Events from '../screens/event/Events';
import Login from '../screens/Login/Login';
import {HomeNavigator} from './homeStack';
import {WalletStack} from '../screens/wallet/wallet.navigator';
import {PortfolioStack} from '../screens/portfolio/portfolio.navigator';
import HashTag from '../screens/hashtag/HashTag';
import Profile from '../screens/Profile/Profile';
import ManageKycBank from '../screens/Profile/ManageKycBank';
import {ClubStack} from '../screens/clubs/clubs.navigator';
import {ContestStack} from '../screens/contest/contest.navigator';
import Refer from '../screens/refernearn/ReferEarn';
import Maintanence from '../commonComponents/Maintanence';
import Home from '../screens/home/Home';
import Portfolio from '../screens/portfolio/Portfolio';
import wallet from '../screens/wallet/wallet';
import Account from '../screens/account/account';
import {isMobile} from '../utils/commonMethods';
import Width from '../assets/Width';
import ProTrader from '../screens/proTrader/proTrader';
import Activity from '../screens/activity/Activity';
import {globalConfigurableData} from '../utils/globalConstant';
import PartnerError from '../commonComponents/PartnerError';
import {Platform, View} from 'react-native';
import WalletSuccess from '../screens/wallet/childScreens/WalletStatus';
import LanguageSelection from '../screens/account/languageSelection';
import PriceSelection from '../screens/account/childScreens/priceSelection';
import LoginOptions from '../screens/Login/childComponents/LoginOptions';
import Direct24 from '../screens/wallet/childComponents/Direct24';
import {RewardsStack} from '../screens/rewards/rewards.navigator';
import LinkqCards from '../screens/wallet/childComponents/LinqCards';

const Stack = createNativeStackNavigator();


export const AppStackNavigator = ({token, isMaintanence}) => {

  
  return (
    <View style={{flex: 1}}>
      <Stack.Navigator
        screenOptions={({route, navigation}) => ({
          headerShown: false,
          gestureEnabled: true,
          contentStyle: {
            paddingHorizontal:
              Width.width > 1200 ? (Width.width - 1200) / 2 : isMobile() ? 0 : 10,
            backgroundColor: globalConfigurableData.globalThemeColor,
          },
        })}>
        {isMaintanence === false ? (
          <>
            <Stack.Screen name="maintanence" component={Maintanence} />
          </>
        ) : !token ? (
          <>
            <Stack.Screen
              name="Home"
              component={isMobile() ? HomeNavigator : Home}
            />
            <Stack.Screen name="HashTag" component={HashTag} />
            <Stack.Screen
              name="Event"
              component={Events}
              options={{animation: 'none'}}
            />
            <Stack.Screen name="ClubStack" component={ClubStack} />
            {isMobile() && (
              <Stack.Screen name="RewardsStack" component={RewardsStack} />
            )}
            <Stack.Screen name="Fantasy" component={ContestStack} />
            <Stack.Screen name="LoginOptions" component={LoginOptions} />
            <Stack.Screen name="Direct24" component={Direct24} />
            <Stack.Screen name="PartnerError" component={PartnerError} />
          </>
        ) : (
          <>
            <Stack.Screen
              name="Home"
              component={isMobile() ? HomeNavigator : Home}
            />
            <Stack.Screen name="HashTag" component={HashTag} />
            <Stack.Screen name="Profile" component={Profile} />
            <Stack.Screen name="manageKycBank" component={ManageKycBank} />
            <Stack.Screen
              name="Event"
              component={Events}
              options={{animation: 'none'}}
            />
            <Stack.Screen name="ProTrader" component={ProTrader} />
            {!isMobile() && (
              <Stack.Screen name="Portfolio" component={Portfolio} />
            )}
            {!isMobile() && <Stack.Screen name="Wallet" component={wallet} />}
            {!isMobile() && <Stack.Screen name="Activity" component={Activity} />}
            <Stack.Screen name="WalletStack" component={WalletStack} />
            <Stack.Screen name="PortfolioStack" component={PortfolioStack} />
            <Stack.Screen name="ClubStack" component={ClubStack} />
            {isMobile() && (
              <Stack.Screen name="RewardsStack" component={RewardsStack} />
            )}
            <Stack.Screen name="Refer" component={Refer} />
            <Stack.Screen name="Fantasy" component={ContestStack} />
            <Stack.Screen name="Account" component={Account} />
            <Stack.Screen name="WalletSuccess" component={WalletSuccess} />
            <Stack.Screen name="LoginOptions" component={LoginOptions} />
            <Stack.Screen
              name="LanguageSelection"
              component={LanguageSelection}
            />
            <Stack.Screen name="PriceSelection" component={PriceSelection} />
            <Stack.Screen name="Direct24" component={Direct24} />
            <Stack.Screen name="PartnerError" component={PartnerError} />
            <Stack.Screen name="LinkqCards" component={LinkqCards} />
          </>
        )}
      </Stack.Navigator>
      <Login />
    </View>
  );
};
